import {designSystem20260615} from './definitions/20260615';
import {designSystem20260616} from './definitions/20260616';
import {designSystemMonochrome} from './definitions/monochrome';
import {ACTIVE_DESIGN_SYSTEM_VERSION} from './designSystemVersion';
import type {DesignSystemDefinition, DesignSystemVersion} from './types';

const designSystemRegistry: Record<DesignSystemVersion, DesignSystemDefinition> = {
  '20260615': designSystem20260615,
  '20260616': designSystem20260616,
  monochrome: designSystemMonochrome,
};

export const getDesignSystem = (
  version: DesignSystemVersion = ACTIVE_DESIGN_SYSTEM_VERSION,
): DesignSystemDefinition => designSystemRegistry[version];

export const getActiveDesignSystem = (): DesignSystemDefinition =>
  getDesignSystem(ACTIVE_DESIGN_SYSTEM_VERSION);

const activeDesignSystem = getActiveDesignSystem();

export const neutral = activeDesignSystem.neutral;
export const greenColors = activeDesignSystem.greenColors;
export const orangeColors = activeDesignSystem.orangeColors;
export const primary = activeDesignSystem.primary;
export const warningColor = activeDesignSystem.warningColor;
export const warningColorLight = activeDesignSystem.warningColorLight;
export const warningColorDark = activeDesignSystem.warningColorDark;
export const actions = activeDesignSystem.actions;
export const accent = activeDesignSystem.accent;
export const text = activeDesignSystem.text;
export const semantic = activeDesignSystem.semantic;
export const scorePill = activeDesignSystem.scorePill;
export const recommendationCallout = activeDesignSystem.recommendationCallout;
export const dataFreshnessBand = activeDesignSystem.dataFreshnessBand;
export const redeploymentChip = activeDesignSystem.redeploymentChip;
export const departmentHealthActionType = activeDesignSystem.departmentHealthActionType;
export const departmentHealthActionPriority = activeDesignSystem.departmentHealthActionPriority;
export const profileComparisonSelection = activeDesignSystem.profileComparisonSelection;
export const alignmentStatus = activeDesignSystem.alignmentStatus;
export const scrollbar = activeDesignSystem.scrollbar;
export const empionOrangeGradient = activeDesignSystem.empionOrangeGradient;

export {ACTIVE_DESIGN_SYSTEM_VERSION} from './designSystemVersion';
export type {DesignSystemDefinition, DesignSystemVersion} from './types';
